namespace Matrix.Workflow {
    export interface ApprovalCommentForm {
        Comment: Serenity.StringEditor;
    }

    export class ApprovalCommentForm extends Serenity.PrefixedContext {
        static formKey = 'Workflow.ApprovalComment';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ApprovalCommentForm.init)  {
                ApprovalCommentForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(ApprovalCommentForm, [
                    'Comment', w0
                ]);
            }
        }
    }
}
